// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__4jWAI","modal":"Modal_modal__vUPzQ","slide-down":"Modal_slide-down__Y9cEZ"};